import { atom } from "jotai";

type MagicFlagSettings = {
  [key: string]: string;
};

const DefaultMagicFlagSettings: MagicFlagSettings = {};

export const magicFlagSettings = atom(DefaultMagicFlagSettings);
